import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { Sidepot } from '../../../../model/sidepot';
import { Organization } from '../../../../model/organization';
import { PayoutConfig } from '../../../../model/payoutConfig';
import { PayoutConfigSchedule } from '../../../../model/payoutConfig-schedule';
import { Rodeo } from '../../../../model/rodeo';

@Component({
    selector: 'new-payout-config',
    templateUrl: 'new-payout-config.html'
})
export class NewPayoutConfig {
    organization: Organization;
    rodeo: Rodeo;
    rodeoEvent: RodeoEvent;
    sidepot: Sidepot;
    payoutConfig: PayoutConfig;

    allSchedules: any[];
    payoutTypes: string[];
    payoutModes: string [];

    constructor(navParams: NavParams, private viewController: ViewController) {
        let existingPayoutConfig = navParams.get('payoutConfig');
        this.organization = navParams.get('organization');
        this.rodeo = navParams.get('rodeo');
        this.rodeoEvent = navParams.get('rodeoEvent');
        this.sidepot = navParams.get('sidepot');

        this.allSchedules = [];
        this.rodeo.rodeoEvents.forEach(rodeoEvent => {
            rodeoEvent.schedules.forEach(schedule => {
                this.allSchedules.push({id: schedule.id, className: rodeoEvent.displayName, name: schedule.name});
            });
        })

        this.payoutTypes = ['Straight', "Ds"];
        this.payoutModes = ['Average', 'Aggregate', 'Per Round', 'Across Rounds', 'Bottoms Up'];

        if (!existingPayoutConfig) {
            this.payoutConfig = new PayoutConfig();
            this.payoutConfig.uniqueRunsOnly = true;
            this.payoutConfig.payoutFormatId = this.payoutConfig.payoutFormatId;
        } else {
            this.payoutConfig = existingPayoutConfig.payoutConfig;
            (this.payoutConfig as any).name = existingPayoutConfig.name;
        }
    }

    create() {
        this.viewController.dismiss(this.payoutConfig);
    }

    cancel() {
        this.viewController.dismiss(null);
    }

    matchPayoutFormats(a, b) {
        return a.id == b.id;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/new-payout-config.ts